import { PD_DOCS_VERSION } from '@shared/config';

import type { AttachmentType } from '../lib/attachments';

// Заявка уходит на свой обработчик (server/app.mjs) на том же домене: сервер на Amvera
// пересылает её письмом через почту в РФ. Сторонних сервисов и передачи за рубеж нет
const ENDPOINT = '/api/quote';

export interface IQuoteAttachment {
  name: string;
  type: AttachmentType;
  /** base64 содержимого, без префикса data: */
  data: string;
}

export interface QuoteRequest {
  name: string;
  company: string;
  /** Телефон или почта */
  contact: string;
  message: string;
  attachments: IQuoteAttachment[];
}

export const sendQuoteRequest = async (data: QuoteRequest): Promise<void> => {
  const response = await fetch(ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...data,
      // Форма не отправляется без галочки — сюда доходит только согласившийся посетитель
      consent: true,
      // Доказательство согласия: в какой редакции документов оно дано
      consentVersion: PD_DOCS_VERSION,
    }),
  });

  const result: unknown = await response.json().catch(() => null);
  const ok =
    response.ok &&
    typeof result === 'object' &&
    result !== null &&
    'success' in result &&
    result.success === true;
  if (!ok) throw new Error('Не удалось отправить заявку');
};
